import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleUp,
} from "@fortawesome/pro-light-svg-icons";
import {
  faGear,
  faPlay,
  faPause,
  faRotate,
  faCheck,
  faScaleUnbalancedFlip,
  faCalendarWeek,
  faClipboardList,
  faCalendar,
  faUserGear,
  faHandshake,
    faMapPin,
    faHand,
    faLightEmergencyOn,
    faTriangleExclamation,
} from "@fortawesome/pro-solid-svg-icons";
import styles from "./notification-accordion.module.scss";
import classNames from "classnames";
import { useTypedSelector } from "../../../../../../store/selectors/selectors.utils";
import FirebaseUsage from "../../../../../../firebase/firebase.usage";
import { COLLECTIONS } from "../../../../../../firebase/constants";
import {useProjectMemberSelector} from "../../../../../../store/selectors/team.selectors";
import {NotificationSettingsModel, NotificationsPreferences} from "../../../../../../models/responses/group.model";
import {subsManager} from "../../../../../../store/middleware/subs-manager/subs-manager";

export default function NotificationModal(props: {isActive: boolean}) {
  const { isActive } = props;
  const projectMember = useProjectMemberSelector();
  const notifcications: NotificationSettingsModel | null = projectMember ? projectMember.notifications : null

  useEffect(() => {
    if (!notifcications) {
      const newNotificationSettings: NotificationSettingsModel = {
        myTasks: NotificationsPreferences.MY_TASKS,
        comments: true,
        starts: true,
        declaredComplete: true,
        approved: true,
        issues: true,
        waiting: true,
        resume: true,
        blocked: true,
        suspended: true,
        forecast: true,
        checklist: true,
        taskForce: true,
        critical: true,
      }
      if (projectMember) {
          FirebaseUsage.updateDoc(COLLECTIONS.PROJECT_MEMBERS, projectMember.memberId, {
              notifications: newNotificationSettings,
          }).catch(e => console.log(e));
      }
    }
  }, [notifcications]);

  const setPreferences = async (preference: string) => {
    let updateValue: any = null;
    if (!notifcications || !projectMember) return
    if (preference === 'myTasks') {
        updateValue = notifcications?.myTasks === NotificationsPreferences.MY_TASKS ? NotificationsPreferences.ALL_TASKS : NotificationsPreferences.MY_TASKS;
    } else {
      updateValue = !notifcications[preference]
    }
    await FirebaseUsage.updateDoc(COLLECTIONS.PROJECT_MEMBERS, projectMember.memberId, {notifications: {...notifcications, [preference]: updateValue}});
  }


  return (
    <div className={styles.NotificationAccordion}>
      {/*<div className="accordion-title" onClick={() => setIsActive(!isActive)}>*/}
      {/*  <div className="navigation-bar-notifications-item-icon">*/}
      {/*    <div className="notification-header">*/}
      {/*      <h4>Notifications</h4>*/}
      {/*    </div>*/}
      {/*    <FontAwesomeIcon*/}
      {/*      icon={isActive ? faAngleUp : faAngleDown}*/}
      {/*      className="chevron-icon"*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*</div>*/}
      {isActive && notifcications && (
          <div className="accordion-content">
            <div className={styles.ContentItem}>
              <h4 className={classNames(styles.Title)}>
                <FontAwesomeIcon icon={faHandshake}/>
                <span>notify my tasks only</span>
              </h4>
              <label className={styles.switch}>
                <input
                    type="checkbox"
                    checked={notifcications.myTasks === NotificationsPreferences.MY_TASKS}
                    onChange={() => {
                      setPreferences("myTasks").catch(e => console.log(e));
                    }}
                />
                <span className={styles.slider}></span>
              </label>
            </div>
            <div className={styles.ContentItem}>
              <h4 className={styles.Title}>
                <FontAwesomeIcon icon={faGear}/>
                <span>task is waiting to start</span>
              </h4>
              <label className={styles.switch}>
                <input
                    type="checkbox"
                    checked={notifcications.waiting}
                    onChange={() => setPreferences("waiting").catch(e => console.log(e))}
                />
                <span className={styles.slider}></span>
              </label>
            </div>
            <div className={styles.ContentItem}>
              <h4 className={styles.Title}>
                <FontAwesomeIcon icon={faPlay}/>
                <span>task has started</span>
              </h4>
              <label className={styles.switch}>
                <input
                    type="checkbox"
                    checked={notifcications.starts}
                    onChange={() => setPreferences("starts").catch(e => console.log(e))}
                />
                <span className={styles.slider}></span>
              </label>
            </div>
            <div className={styles.ContentItem}>
              <h4 className={styles.Title}>
                <FontAwesomeIcon icon={faPause}/>
                <span>task has been suspended</span>
              </h4>
              <label className={styles.switch}>
                <input
                    type="checkbox"
                    checked={notifcications.suspended}
                    onChange={() => setPreferences("suspended").catch(e => console.log(e))}
                />
                <span className={styles.slider}></span>
              </label>
            </div>
            <div className={styles.ContentItem}>
              <h4 className={styles.Title}>
                <FontAwesomeIcon icon={faHand}/>
                <span>task has been blocked</span>
              </h4>
              <label className={styles.switch}>
                <input
                    type="checkbox"
                    checked={notifcications.blocked}
                    onChange={() => setPreferences("blocked").catch(e => console.log(e))}
                />
                <span className={styles.slider}></span>
              </label>
            </div>
            <div className={styles.ContentItem}>
              <h4 className={styles.Title}>
                <FontAwesomeIcon icon={faMapPin}/>
                <span>task has been reforecast</span>
              </h4>
              <label className={styles.switch}>
                <input
                    type="checkbox"
                    checked={notifcications.forecast}
                    onChange={() => setPreferences("forecast").catch(e => console.log(e))}
                />
                <span className={styles.slider}></span>
              </label>
            </div>
            <div className={styles.ContentItem}>
              <h4 className={styles.Title}>
                <FontAwesomeIcon icon={faRotate}/>
                <span>task has resumed</span>
              </h4>
              <label className={styles.switch}>
                <input
                    type="checkbox"
                    checked={notifcications.resume}
                    onChange={() => setPreferences("resume").catch(e => console.log(e))}
                />
                <span className={styles.slider}></span>
              </label>
            </div>
            <div className={styles.ContentItem}>
              <h4 className={styles.Title}>
                <FontAwesomeIcon icon={faScaleUnbalancedFlip}/>
                <span>task is ready for approval</span>
              </h4>
              <label className={styles.switch}>
                <input
                    type="checkbox"
                    checked={notifcications.declaredComplete}
                    onChange={() => setPreferences("declaredComplete").catch(e => console.log(e))}
                />
                <span className={styles.slider}></span>
              </label>
            </div>
            <div className={styles.ContentItem}>
              <h4 className={styles.Title}>
                <FontAwesomeIcon icon={faCheck}/>
                <span>task is approved</span>
              </h4>
              <label className={styles.switch}>
                <input
                    type="checkbox"
                    checked={notifcications.approved}
                    onChange={() => setPreferences("approved").catch(e => console.log(e))}
                />
                <span className={styles.slider}></span>
              </label>
            </div>
            <div className={styles.ContentItem}>
              <h4 className={styles.Title}>
                <FontAwesomeIcon icon={faTriangleExclamation}/>
                <span>task issues logged</span>
              </h4>
              <label className={styles.switch}>
                <input
                    type="checkbox"
                    checked={notifcications.issues}
                    onChange={() => setPreferences("issues").catch(e => console.log(e))}
                />
                <span className={styles.slider}></span>
              </label>
            </div>
            <div className={styles.ContentItem}>
              <h4 className={styles.Title}>
                <FontAwesomeIcon icon={faClipboardList}/>
                <span>checklist item actions</span>
              </h4>
              <label className={styles.switch}>
                <input
                    type="checkbox"
                    checked={notifcications.checklist}
                    onChange={() => setPreferences("checklist").catch(e => console.log(e))}
                />
                <span className={styles.slider}></span>
              </label>
            </div>
            <div className={styles.ContentItem}>
              <h4 className={styles.Title}>
                <FontAwesomeIcon icon={faUserGear}/>
                <span>task membership changes</span>
              </h4>
              <label className={styles.switch}>
                <input
                    type="checkbox"
                    checked={notifcications.taskForce}
                    onChange={() => setPreferences("taskForce").catch(e => console.log(e))}
                />
                <span className={styles.slider}></span>
              </label>
            </div>
            <div className={styles.ContentItem}>
              <h4 className={styles.Title}>
                <FontAwesomeIcon icon={faLightEmergencyOn}/>
                <span>task has become critical</span>
              </h4>
              <label className={styles.switch}>
                <input
                    type="checkbox"
                    checked={notifcications.critical}
                    onChange={() => setPreferences("critical").catch(e => console.log(e))}
                />
                <span className={styles.slider}></span>
              </label>
            </div>
          </div>
      )}
    </div>
  );
};
